import { api } from "@/lib/api";


export const getModuleReaderMetadata = async (moduleCode) => {
  const response = await api.get(`/student/modules/${moduleCode}/reader`);
  return response.data;
};


export const getModuleReaderPageBlob = async (moduleCode, pageNumber) => {
  const response = await api.get(`/student/modules/${moduleCode}/reader/pages/${pageNumber}`, {
    responseType: "blob",
  });
  return response.data;
};
